
import Node from "components/Node.vue";
import themes from "data/themes";
import { CoercableComponent, Visibility } from "features/feature";
import settings from "game/settings";
import { computeComponent, processedPropType } from "util/vue";
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition.vue";
import { computed, defineComponent, PropType, Ref, StyleValue, toRefs, unref } from "vue";

export default defineComponent({
    props: {
        visibility: {
            type: processedPropType<Visibility>(Number),
            required: true
        },
        display: {
            type: processedPropType<CoercableComponent>(Object, String, Function),
            required: true
        },
        title: {
            type: processedPropType<CoercableComponent>(Object, String, Function),
            required: true
        },
        color: processedPropType<string>(String),
        collapsed: {
            type: Object as PropType<Ref<boolean>>,
            required: true
        },
        style: processedPropType<StyleValue>(Object, String, Array),
        titleStyle: processedPropType<StyleValue>(Object, String, Array),
        bodyStyle: processedPropType<StyleValue>(Object, String, Array),
        classes: processedPropType<Record<string, boolean>>(Object),
        id: {
            type: String,
            required: true
        }
    },
    components: {
        Node,
        CollapseTransition
    },
    setup(props) {
        const { title, display } = toRefs(props);

        const titleComponent = computeComponent(title);
        const bodyComponent = computeComponent(display);
        const stacked = computed(() => themes[settings.theme].mergeAdjacent);

        return {
            titleComponent,
            bodyComponent,
            stacked,
            unref,
            Visibility
        };
    }
});
